export const Hints = {
  myTeamHint: 'myTeamHint'
} as const
